import create from 'zustand';

import { MediaApprovalMaType } from '../graphql/query/moderate.queries';

export type DateRangeType = 'today' | 'lastWeek' | 'lastMonth' | 'oldest' | null;

export interface ModerateFilters {
  dateRange: DateRangeType;
  contentTypes: MediaApprovalMaType[];
  categories: string[];
}

interface ModerateState {
  filters: ModerateFilters;
  setFilters: (filters: Partial<ModerateFilters>) => void;
  resetFilters: () => void;
}

export const useModerateStore = create<ModerateState>((set) => ({
  filters: {
    dateRange: null,
    contentTypes: [],
    categories: [],
  },
  setFilters: (newFilters) =>
    set((state) => ({
      filters: { ...state.filters, ...newFilters },
    })),
  resetFilters: () =>
    set({
      filters: {
        dateRange: null,
        contentTypes: [],
        categories: [],
      },
    }),
}));
